import { useCallback } from 'react'
import * as Sentry from '@sentry/react'

const isStaging = import.meta.env.VITE_SENTRY_ENV === 'staging'

export function SentryCrashButton() {
  if (!isStaging || !import.meta.env.VITE_SENTRY_DSN) return null

  const handleClick = useCallback(() => {
    const error = new Error('Sentry staging crash test (admin)')
    const eventId = Sentry.captureException(error)

    console.log('[Sentry] captured crash event (admin)', eventId)
    void Sentry.flush(2000).finally(() => {
      throw error
    })
  }, [])

  return (
    <button
      type="button"
      onClick={handleClick}
      className="fixed bottom-4 right-4 z-[9999] rounded-md bg-neutral-900/70 px-3 py-2 text-xs font-medium text-white shadow-md transition hover:bg-neutral-800/90"
      aria-label="Trigger Sentry crash (staging only)"
    >
      Crash (Sentry)
    </button>
  )
}
